const Loading: React.FC = () => {
  // Render
  return <div>Loading...</div>;
};

export default Loading;
